import React, { useEffect, useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { VideoSection } from '../components/VideoSection';
import { AnxietyTest } from '../components/AnxietyTest';
import { OfferSection } from '../components/OfferSection';
import { ProblemSection } from '../components/ProblemSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { DetailsSection } from '../components/DetailsSection';
import { SpiritualBackground } from '../components/SpiritualBackground';
import { LegalModal } from '../components/LegalModal';
import { ChatWidget } from '../components/ChatWidget';
import { PromoBanner } from '../components/PromoBanner';
export function SalesPage() {
  useEffect(() => {
    document.title = 'Método AnsExpress';
  }, []);
  const [legalModal, setLegalModal] = useState<{
    open: boolean;
    tab: 'terms' | 'privacy';
  }>({
    open: false,
    tab: 'terms'
  });
  return <main className="font-sans antialiased min-h-screen relative bg-[#F7F7F5]" data-id="element-360">
      <SpiritualBackground data-id="element-361" />

      {/* Sticky Top CTA Banner */}
      <a href="#offer" className="fixed top-0 left-0 right-0 z-50 bg-[#5BBFB5] text-white text-center py-3 px-4 font-semibold text-sm md:text-base tracking-wide shadow-md hover:bg-[#4DAF9F] transition-colors cursor-pointer" style={{
      animation: 'pulse-glow 2s ease-in-out infinite'
    }} data-id="element-362">
        🔥 Super Promo: Todos los productos a $7.99 USD — ¡Solo por esta semana!
        🔥
      </a>

      <div className="relative z-10" data-id="element-363">
        {/* 0. Promo Banner */}
        <PromoBanner data-id="element-364" />

        {/* 1. Logo del producto */}
        <HeroSection data-id="element-365" />

        {/* 2. Video */}
        <VideoSection data-id="element-366" />

        {/* 3. Test de ansiedad */}
        <AnxietyTest data-id="element-367" />

        {/* 4. Botón de compra */}
        <OfferSection data-id="element-368" />

        {/* Supporting Sections */}
        <ProblemSection data-id="element-369" />
        <ProtocolSection data-id="element-370" />
        <DetailsSection data-id="element-371" />

        <footer className="bg-transparent text-[#7A7A7A] py-12 text-center text-sm space-y-4" data-id="element-372">
          <div className="flex items-center justify-center gap-4" data-id="element-373">
            <button onClick={() => setLegalModal({
            open: true,
            tab: 'terms'
          })} className="hover:text-[#5BBFB5] transition-colors font-medium" data-id="element-374">
              Términos y Condiciones
            </button>
            <span className="text-[#E8E8E6]" data-id="element-375">•</span>
            <button onClick={() => setLegalModal({
            open: true,
            tab: 'privacy'
          })} className="hover:text-[#5BBFB5] transition-colors font-medium" data-id="element-376">
              Política de Privacidad
            </button>
          </div>
          <p className="font-light" data-id="element-377">
            &copy; {new Date().getFullYear()} Ansiedad Exprés. Todos los
            derechos reservados.
          </p>
        </footer>
      </div>

      <LegalModal isOpen={legalModal.open} onClose={() => setLegalModal({
      ...legalModal,
      open: false
    })} initialTab={legalModal.tab} data-id="element-378" />

      <ChatWidget data-id="element-379" />
    </main>;
}